import { createContext } from "react";

const aboutContext = createContext();

export default aboutContext;